<template>
  <div class="reaction-button-wrap">
    <b-button
      :id="buttonId"
      :variant="statusVariant"
      size="sm"
      class="reaction-button"
      :disabled="!!error"
      @click.prevent="onClick"
    >
      <i
        :class="`${iconReacted}`"
        v-if="iconReacted && reacted"
      ></i>
      <i
        :class="`${iconUnreacted}`"
        v-if="iconUnreacted && !reacted"
      ></i>
      <span class="ml-1">
        {{ title }}
      </span>
    </b-button>
    <b-tooltip
      :show="!error"
      :target="buttonId"
      placement="right"
    >
      {{ count }}
    </b-tooltip>
  </div>
</template>

<style lang="scss" scoped>
.reaction-button-wrap {

  .reaction-button {
    flex: 1;
    margin-right: 0.5rem;
  }

  .reaction-count {
    display: inline-block;
    height: 1.5rem;
    font-size: 1rem;
    text-align: center;
    border-radius: 999px;
    color: #fff;
    padding: 0 0.5rem;
  }
}
</style>

<script>
import VueTypes from 'vue-types'
import capitalize from 'lodash/capitalize'
import get from 'lodash/get'

import { getReactionStatus, toggleReaction } from '@/api'
import wait from '@/lib/wait'

export default {
  name: 'ReactionButton',

  props: {
    type: VueTypes.string.isRequired,
    to: VueTypes.string.isRequired,
    id: VueTypes.oneOfType([
      VueTypes.string,
      VueTypes.integer
    ]).isRequired,
    label: VueTypes.string,
    variant: VueTypes.string.def('primary'),
    iconReacted: VueTypes.string,
    iconUnreacted: VueTypes.string
  },

  data () {
    return {
      reaction: null,
      error: ''
    }
  },

  computed: {
    buttonId () {
      return `reaction-button-${this._uid}`
    },

    title () {
      return this.label || capitalize(this.type)
    },

    reacted () {
      return !!get(this.reaction, 'id')
    },

    count () {
      return get(this.reaction, 'count', 0)
    },

    statusVariant () {
      return this.reacted ? this.variant : `outline-${this.variant}`
    },

    bgVariant () {
      return `bg-${this.variant}`
    }
  },

  mounted () {
    this.loadStatus()
  },

  methods: {
    loadStatus () {
      getReactionStatus(this.to, this.id, this.type).then(response => {
        this.reaction = response.data
      }).catch(error => {
        this.error = Object.values(error.response.data.errors)[0][0]
      })
    },

    toggle () {
      wait.saving()

      toggleReaction(this.to, this.id, this.type).then(response => {
        this.reaction = response.data

        wait.saved()
      }).catch(() => {
        wait.oops()
      })
    },

    onClick () {
      this.toggle()
    }
  }
}
</script>
